module.exports = __webpack_public_path__ + "img/inster.212a3766.png";